import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { UserAdminReport } from '@/module/AnnualReport/perRole/UserAdminReport';

import { NoContentPlaceholder } from '@/core/components';

import { HierarchyDepartmentSelect } from '@feature/utils/components/HierarchyDepartmentSelect';
import { useDepartmentAdminHierarchy } from '@feature/utils/components/hooks/hierarchy/useHierarchy';
import { ValidationStatus } from '@feature/validation';

export interface DepartmentAdminReportProps {
  year: number;
  validationStatus: ValidationStatus | null;
  filterAfterAffiliation: boolean;
}

export function DepartmentAdminReport({ year, validationStatus, filterAfterAffiliation }: DepartmentAdminReportProps) {
  const { userId, selectProps } = useDepartmentAdminHierarchy();
  const { t } = useTranslation();

  return (
    <Stack>
      <HierarchyDepartmentSelect {...selectProps} />
      {userId == null && <NoContentPlaceholder title={t('hierarchySelectValidation.fromDepartments')} />}
      {userId != null && (
        <UserAdminReport
          userId={userId}
          year={year}
          validationStatus={validationStatus}
          filterAfterAffiliation={filterAfterAffiliation}
        />
      )}
    </Stack>
  );
}
